<template>
    <div :class="icon" class="avatar"></div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';

.avatar {
    @include icon(30px, 30px);
    cursor: default;

    &.PRODUCT_CREATED {
        background-image: url('./icons/product_created.svg');
    }

    &.PRODUCT_DELETED,
    &.DRAFT_DELETED {
        background-image: url('./icons/card_remove.svg');
    }

    &.RATED {
        background-image: url('./icons/card_liked.svg');
    }

    &.PRODUCT_PUBLISHED {
        background-image: url('./icons/product_published.svg');
    }

    &.DRAFT_PUBLISHED {
        background-image: url('./icons/draft_published.svg');
    }

    &.DRAFT_CREATED {
        background-image: url('./icons/draft_created.svg');
    }

    &.PRODUCT_UNARCHIVED {
        background-image: url('./icons/archived.svg');
    }

    &.MESSAGE {
        background-image: url('./icons/moderate_message.svg');
    }

    &.TAG_ADDED,
    &.TAG_ALIAS_ADDED {
        background-image: url('./icons/tag_added.svg');
    }
}
</style>
